import React, { useState, useRef, useEffect } from "react";
import { Button, Modal, Form, Alert } from "react-bootstrap";
import { apiUrl, myFetchPost } from "../utility";
import "../css/ChatRoomModal.css";
import { getMessaging, getToken, isSupported } from "firebase/messaging";
import { messaging } from "../utility/firebase";

const delayFunction = (delay) => {
  return new Promise((res, rej) => {
    setTimeout(() => {
      res("finish");
    }, delay);
  });
};

const NotificationRequestModal = (props) => {
  const { currentUser } = props;

  const delay = props?.delay ? props?.delay : 800;
  const remindTimeStep = props.remindTimeStep ? props.remindTimeStep : 86400;
  const sourceScreen = props.sourceScreen ? props.sourceScreen : "default";
  const disablePersistent = props.disablePersistent
    ? props.disablePersistent
    : false;

  const [isBrowserGranted, setIsBrowserGranted] = useState("default");
  const [isBrowserSupported, setIsBrowserSupported] = useState(false);

  const timer = useRef();

  const [showWarningModal, setShowWarningModal] = useState(false);
  const [warningTitle, setWarningTitle] = useState("");
  const [warningMessage, setWarningMessage] = useState("");
  const [screenOverlay, setScreenOverlay] = useState(false);

  const [showNotificationRequestModal, setShowNotificationRequestModal] =
    useState(false);

  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    isSupported()
      .then((isMessagingSupported) => {
        if (isMessagingSupported) {
          setIsBrowserSupported(true);
          const pushNotificationStatus =
            window.localStorage.getItem("pushnotification");

          if (pushNotificationStatus != "true" && (Notification.permission == 'default')) {
            if (disablePersistent) {
              if (!isDismissed) {
                if (pushNotificationStatus != "true") {
                  timer = setTimeout(
                    () => {
                      setShowNotificationRequestModal(true);
                    },
                    delay ? delay : 800
                  );
                }
              }
            } else {
              const notificationReminder = window.localStorage.getItem(
                "pushNotificationReminder_" + sourceScreen
              );
              const notificationReminderObj = JSON.parse(notificationReminder);
              const remindCounter =
                notificationReminderObj == null
                  ? 0
                  : notificationReminderObj.remindCounter;
              const remindTime =
                notificationReminderObj == null
                  ? 0
                  : notificationReminderObj.remindTime;
              if (
                Math.round(new Date().getTime() / 1000) > remindTime &&
                remindCounter <= 10
              ) {
                timer = setTimeout(
                  () => {
                    setShowNotificationRequestModal(true);
                  },
                  delay ? delay : 800
                );
              }
            }
          }
        }
      })
      .catch((error) => {});
  }, []);

  const subscribeToServer = async (
    subscribeType,
    currentToken,
    previousToken = ""
  ) => {
    return currentUser.getIdToken().then((token) => {
      const requestData = {
        form_action: subscribeType,
        currentToken: currentToken,
        previousToken: previousToken,
        platform: "webapp",
      };
      if (subscribeType == "subscribe") {
        return myFetchPost(`${apiUrl}/notification/subscribe`, requestData, {
          Authorization: "Bearer " + token,
        });
      } else if (subscribeType == "unsubscribe") {
        return myFetchPost(`${apiUrl}/notification/unsubscribe`, requestData, {
          Authorization: "Bearer " + token,
        });
      }
    });
  };

  const handleEnableNotification = async () => {
    /* enable push notification */
    if (Notification.permission == "denied") {
      setShowNotificationRequestModal(false);
      setWarningTitle("開啟 DCFever 通知功能");
      setWarningMessage(
        '1. 在瀏覽器的位址列中選擇鎖頭圖示 <i class="bi bi-lock-fill"></i>。<br>2. 找到 <i class="bi bi-bell-fill"></i> 通知，然後選擇「允許」。<br>3. 選擇下方的開啟。'
      );
      setShowWarningModal(true);
    } else {
      try {
        setScreenOverlay(
          Notification.permission == "default"
            ? "isBlackScreen"
            : "isSubmitting"
        );
        isSupported()
          .then(async (isMessagingSupported) => {
            if (isMessagingSupported) {
              const permission = await Notification.requestPermission();
              //alert('after requestPermission: ' + permission)
              if (permission !== 'granted') {
                //alert('通知權限被拒絕。請在瀏覽器設置中允許通知。');
                setScreenOverlay(false);
                setWarningTitle("開啟 DCFever 通知功能");
                setWarningMessage(
                  '1. 在瀏覽器的位址列中選擇鎖頭圖示 <i class="bi bi-lock-fill"></i>。<br>2. 找到 <i class="bi bi-bell-fill"></i> 通知，然後選擇「允許」。<br>3. 選擇下方的開啟。'
                );
                setShowNotificationRequestModal(false);
                setShowWarningModal(true);
                return;
              }

              const messaging = getMessaging();
              try {
                const currentToken = await getToken(messaging, {
                  vapidKey:
                    "BHIw2Juj5M2Y8l5atJxE-NDIpzdKWDVAVilnnN8DgBs8RrfqXLOewqwPteIli1L5oGh3NtQL21emL9XmS0_u5sw",
                });
                setShowNotificationRequestModal(false);

                if (currentToken) {
                  const previousToken = window.localStorage.getItem("fcmToken");
                  const subscribeRes = await subscribeToServer(
                    "subscribe",
                    currentToken,
                    previousToken
                  );

                  setScreenOverlay(false);

                  if (subscribeRes.result == "success") {
                    window.localStorage.setItem("fcmToken", currentToken);
                    window.localStorage.setItem("pushnotification", true);
                    setShowWarningModal(false);
                    alert(
                      "成功開啟「瀏覽器推送通知」，當有新的對話、出價、成交確認時，你將會收到即時通知你。"
                    );
                  }
                } else {
                  alert(
                    "No registration token available. Request permission to generate one."
                  );
                }
              } catch (error) {
                setScreenOverlay(false);
                alert('未能成功處理你的請求，請重試! 如果問題持續，請聯絡我們。');
              }
            }
          })
          .catch((error) => {
            setScreenOverlay(false);
            alert("開啟「瀏覽器推送通知」未能成功，請重試。");
          });
      } catch (error) {
        setScreenOverlay(false);
        alert("請更改瀏覽器設定為「允許接收推送通知」才可接收通知");
      }
    }
  };

  const handleWarningManualEnableNotification = async () => {
    try {
      const isMessagingSupported = await isSupported();
      if (isMessagingSupported) {
        const messaging = getMessaging();
        const currentToken = await getToken(messaging, {
          vapidKey:
            "BHIw2Juj5M2Y8l5atJxE-NDIpzdKWDVAVilnnN8DgBs8RrfqXLOewqwPteIli1L5oGh3NtQL21emL9XmS0_u5sw",
        });
        if (currentToken) {
          const subscribeRes = await subscribeToServer(
            "subscribe",
            currentToken,
            window.localStorage.getItem("fcmToken")
          );

          if (subscribeRes.result == "success") {
            window.localStorage.setItem("fcmToken", currentToken);
            window.localStorage.setItem("pushnotification", true);
            setShowWarningModal(false);
            alert(
              "成功開啟「瀏覽器推送通知」，當有新的對話、出價、成交確認時，你將會收到即時通知你"
            );
          }
        } else {
          alert(
            "No registration token available. Request permission to generate one."
          );
        }
      }
    } catch (error) {
      alert("請更改瀏覽器設定為「允許接收推送通知」才可接收通知", error);
    }
  };

  /* handle user click "remind me later" on the notification permission request */
  /* changed the logic to use a counter and increasing delay for each dismissal, with a reset after 6 dismissals or 2 months */
  /* modified on 13/6/2026 */

  const handleLater = async () => {
    setShowNotificationRequestModal(false);
    if (disablePersistent) {
      setIsDismissed(true);
    } else {
      const twoMonthsInSeconds = 60 * 24 * 60 * 60; // ~60 days
      const notificationReminder = window.localStorage.getItem(
        "pushNotificationReminder_" + sourceScreen
      );
      const notificationReminderObj = JSON.parse(notificationReminder);
      const remindCounter =
        notificationReminderObj?.remindCounter == null
          ? 1
          : parseInt(notificationReminderObj?.remindCounter) + 1;

      let newRemindCounter;
      let newRemindTime;

      if (remindCounter >= 10) {
        /* 10th dismissal reached — reset cycle and wait 2 months */
        newRemindCounter = 0;
        newRemindTime = Math.round(new Date().getTime() / 1000) + twoMonthsInSeconds;
      } else {
        /* within the 10-reminder cycle — increasing delay each time */
        newRemindCounter = remindCounter;
        newRemindTime = Math.round(new Date().getTime() / 1000) + remindTimeStep * remindCounter;
      }

      const notificationObject = {
        remindCounter: newRemindCounter,
        remindTime: newRemindTime,
      };

      window.localStorage.setItem(
        "pushNotificationReminder_" + sourceScreen,
        JSON.stringify(notificationObject)
      );
    }
  };

  return (
    <>
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showNotificationRequestModal}
        onHide={() => {
          setShowNotificationRequestModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title className="modalTitle">開啟瀏覽器即時通知</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            dangerouslySetInnerHTML={{
              __html: "當有新的對話、出價、成交確認時，我們可以即時通知你。",
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              handleLater();
            }}
          >
            再想想
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleEnableNotification();
            }}
          >
            立即開啟
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showWarningModal}
        onHide={() => {
          setShowWarningModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "18px" }}>{warningTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: warningMessage }} />
        </Modal.Body>
        <Modal.Footer>
          {!isBrowserGranted && <Button variant="secondary">開啟</Button>}
          {isBrowserGranted && (
            <Button
              variant="primary"
              onClick={() => {
                handleWarningManualEnableNotification();
              }}
            >
              開啟
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      {screenOverlay == "isBlackScreen" && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            position: "absolute",
            top: "0px",
            right: "0px",
            bottom: "0px",
            left: "0px",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            zIndex: 100000,
          }}
          onClick={() => {
            setScreenOverlay(false);
          }}
        ></div>
      )}
    </>
  );
};

export default NotificationRequestModal;
